export default {
    key:'market_admin',
    dashboard: {
        component:'MarketIndex',
        links: {
            sidebar:[
                {
                    icon:'fas fa-fw fa-tachometer-alt',
                    text:'Entity Admins',
                    route:'/market_admin',
                    active:'entityadmins'
                },
                {
                    icon:'fas fa-poll',
                    text:'Markets',
                    route:'/markets',
                    active:'markets'
                },
                {
                    icon:'fa fa-user-cog',
                    text:'Settings',
                    route:'/settings',
                    active:'settings'
                }
            ]
        }
    }
}